import React from "react";
import TimelineContent from '@mui/lab/TimelineContent';
import Typography from "@mui/material/Typography";
import {Divider, Stack} from "@mui/material";
import Box from "@mui/material/Box";
import {formatCompactDateUtc} from "../utils/dateUtils";

export default function ZiggyEvent(props) {

    const date = props.date !== null ? formatCompactDateUtc(props.date) : ''

    return <Stack direction={"row"} alignItems={"start"} justifyContent={"center"}>
        <Stack direction={"column"} alignItems={"center"} justifyContent={"center"}>
            <Box color={date !== "not available" ? "primary" : 'lightgrey'}>
                {props.children}
            </Box>

            <TimelineContent
                sx={{
                    textAlign: 'center',
                    minWidth: props.minWidth || 120,
                    position: 'relative',
                    zIndex: 2
                }}
                variant="caption"
            >
                <Stack>
                    <Box>
                        <Typography variant="h6"
                                    sx={{
                                        fontSize: '135%',
                                        color: date !== "not available" ? "black" : 'lightgrey'
                                    }}>
                            {props.title}
                        </Typography>
                    </Box>

                    <Box>
                        <Typography fontWeight='light'>
                            {props.date !== null && !['Estimated Delivery', 'For Pickup'].includes(props.title) &&
                                date}
                            {props.date !== null && ['Estimated Delivery', 'For Pickup'].includes(props.title) &&
                                `${date} (est.)`}
                            {!props.date && (props.title === 'Estimated Delivery') &&
                                'TBD'}
                        </Typography>
                    </Box>
                </Stack>

            </TimelineContent>
        </Stack>

        {!props.last && <Box alignSelf='center'>
            <Divider sx={{color: 'black', minWidth: 20}}/>
        </Box>}

    </Stack>

}
